module.exports = __webpack_public_path__ + "static/img/C4D0029.0087282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0029.jpg
// module id = xIrH
// module chunks = 0